import React, { Component } from 'react';

class IconCenter extends Component
{
    render = () =>
	{
        return (
            <svg className={ this.props.className } version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	             viewBox="0 0 283.465 283.465" enableBackground="new 0 0 283.465 283.465"
	            xmlSpace="preserve">
            <rect width="283.465" height="283.465"/>
            <g>
	        <defs>
		        <rect id="SVGID_1_" width="283.465" height="283.465"/>
	        </defs>
	        <clipPath id="SVGID_2_">
		        <use xlinkHref="#SVGID_1_"  overflow="visible"/>
	        </clipPath>
	        <path clipPath="url(#SVGID_2_)" d="M149.127,226.757V192.22h-0.3c0.005-0.111,0.065-0.207,0.065-0.319
		        c0-4.021-3.26-7.28-7.28-7.28c-4.02,0-7.279,3.259-7.279,7.28c0,0.112,0.059,0.208,0.064,0.319h-0.064v34.537
		        c-41.25-3.548-74.079-36.378-77.626-77.628h34.61c0.057,0.002,0.103,0.033,0.16,0.033c4.021,0,7.28-3.259,7.28-7.28
		        c0-4.02-3.259-7.279-7.28-7.279c-0.042,0-0.076,0.023-0.117,0.023v-0.29H56.708c3.547-41.25,36.376-74.08,77.626-77.628v34.537
		        h0.017c0.048,3.979,3.272,7.195,7.262,7.195s7.214-3.216,7.263-7.195h0.252V56.708c41.251,3.545,74.083,36.376,77.63,77.628
		        h-34.423v0.29c-0.041,0-0.074-0.023-0.116-0.023c-4.021,0-7.28,3.259-7.28,7.279c0,4.021,3.259,7.28,7.28,7.28
		        c0.057,0,0.103-0.031,0.159-0.033h34.38C223.21,190.381,190.378,223.212,149.127,226.757 M141.732,244.147
		        c56.562,0,102.414-45.854,102.414-102.415c0-56.562-45.853-102.415-102.414-102.415c-56.562,0-102.414,45.853-102.414,102.415
		        C39.318,198.294,85.17,244.147,141.732,244.147"/>
            </g>
        </svg>
        );
    }
}

IconCenter.defaultProps = {
	className: 'icon'
};

export default IconCenter;


// WEBPACK FOOTER //
// ./src/components/App/IconCenter.js